import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { AmplifyProvider } from "./contexts/AmplifyContext";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <AmplifyProvider>
      <App />
    </AmplifyProvider>
  </React.StrictMode>,
);
